import { render } from "./ChangePassword.vue?vue&type=template&id=65d7797c"
const script = {}

import exportComponent from "/home/runner/work/web-frontend-dev/web-frontend-dev/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__